import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsInternship } from '#/modules/search/constants/useSearchFacetsInternship';
import { useSearchQuery } from '#/modules/search/contexts/SearchContext';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';

export function SearchInternshipsPage() {
  const { i18n } = useI18n();

  const query = useSearchQuery();

  const { internshipSearchFacets } = useSearchFacetsInternship(i18n);

  return (
    <SearchPage
      searchFacets={internshipSearchFacets}
      searchType="INTERNSHIP"
      showSortOptions={Boolean(query)}
    />
  );
}
